/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MinimalCity = {
    zip: string;
    name: string;
    federalStateCode: MinimalCity.federalStateCode;
    countryCode: MinimalCity.countryCode;
};
export namespace MinimalCity {
    export enum federalStateCode {
        BW = 'BW',
        BY = 'BY',
        BE = 'BE',
        BB = 'BB',
        HB = 'HB',
        HH = 'HH',
        HE = 'HE',
        MV = 'MV',
        NI = 'NI',
        NW = 'NW',
        RP = 'RP',
        SL = 'SL',
        SN = 'SN',
        ST = 'ST',
        SH = 'SH',
        TH = 'TH',
    }
    export enum countryCode {
        DE = 'DE',
    }
}

